/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import Loading from "../../../components/shared/loading/Loading";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, clientSideUrl } from "../../../utility/Constant";

const BoardContentPage = () => {
  const { boardApi } = apiPath;
  const { clientDirectors } = clientSideUrl;
  const [certificateContentData, certificateContentLoading] =
    useFetch(boardApi);

  if (certificateContentLoading) {
    return <Loading />;
  }

  const {
    image,
    description,
    title,
    subtitle,
    banner_description,
    section_title,
    tagline,
    _id,
  } = certificateContentData[0];

  const bannerData = [
    {
      elementType: "input",
      label: "Banner title",
      type: "Text",
      name: "title",
      defaultValue: title,
      required: false,
    },
    {
      elementType: "input",
      label: "Banner Subtitle",
      type: "Text",
      name: "subtitle",
      defaultValue: subtitle,
      required: false,
    },
    {
      elementType: "textField",
      label: "description",
      type: "Text",
      name: "description",
      defaultValue: description,
      required: false,
    },
    {
      elementType: "textField",
      label: "banner description",
      type: "Text",
      name: "banner_description",
      defaultValue: banner_description,
      required: false,
    },
    {
      elementType: "file",
      label: `Banner Image`,
      name: "banner_image",
      type: "file",
      fullCol: true,
      defaultValue: image,
      required: false,
    },
  ];
  const sectionData = [
    {
      elementType: "input",
      label: "Tagline",
      type: "Text",
      name: "tagline",
      defaultValue: tagline,
      required: false,
    },
    {
      elementType: "input",
      label: "Section title",
      type: "Text",
      name: "section_title",
      defaultValue: section_title,
      required: false,
    },
  ];

  const update = (data) => {
    const { banner_image, ...rest } = data;
    if (banner_image) {
      rest.image = {
        url: banner_image,
      };
    }
    updateData(boardApi, rest, _id);
    setTimeout(() => {
      window.location.reload();
    }, 800);
  };

  return (
    <div>
      <div className="mb-2 w-full text-right font-semibold text-sm">
        <Link
          className="text-blue-600 hover:text-blue-500"
          to={clientDirectors}
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit page
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="inline w-4 h-4 ml-1 align-text-top"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
              />
            </svg>
          </span>
        </Link>
      </div>
      <div>
        <h1 className="font-oswald font-bold text-2xl -mb-4 md:-mb-10 uppercase">
          banner content
        </h1>
        <GlobalForm data={bannerData} update={update} />
      </div>
      <div>
        <h1 className="font-oswald font-bold text-2xl mt-8 -mb-4 md:-mb-10 uppercase">
          Section info
        </h1>
        <GlobalForm data={sectionData} update={update} />
      </div>
    </div>
  );
};

export default BoardContentPage;
